import { Component, inject, input } from '@angular/core';
import { DateTimeRangeDTO, PlaybackScheduleSlotFullDTO, ScreenFullDTO, SharedPlaybackScheduleDTO } from '../../services/api/api';
import { UtilService } from '../../services/util.service';
import { ModalService } from '../../services/gui/modal/modal.service';
import { SbDateTimeRangeViewerComponent } from '../controls/sb-date-time-range-viewer/sb-date-time-range-viewer.component';
import { SelectDetailsResult, SelectDetailsValue } from '../../services/gui/modal/modal.model';
import { RoutingID } from '../../routes/sb-routing-enum';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@ngx-seatback/utils';

@Component({
  selector: 'sb-comp-shared-playback-schedules',
  templateUrl: './shared-playback-schedules.component.html',
  styleUrls: ['./shared-playback-schedules.component.scss'],
  standalone: false,
})
export class SharedPlaybackSchedulesComponent {
  protected readonly util = inject(UtilService);
  protected readonly modalService = inject(ModalService);
  protected readonly translate = inject(TranslateService);
  protected readonly navService = inject(NavigationService);

  sharedPlaybackSchedules = input.required<SharedPlaybackScheduleDTO[]>();
  isInDeviceContext = input<boolean>(false);
  currentSchedule: string = '1';

  showDateTimeRanges(ranges: DateTimeRangeDTO[]) {
    this.modalService
      .showNavigationModal({
        entryComponent: { value: SbDateTimeRangeViewerComponent, data: { dateTimeRanges: ranges } },
        title: null,
        modalOptions: { size: 'lg' },
      })
      .then(() => {})
      .catch(() => {});
  }

  showScreensModal(screens: ScreenFullDTO[]) {
    if (this.isInDeviceContext()) {
      return;
    }
    const selectDetailsValues: SelectDetailsValue<number>[] = [];

    for (const screen of screens) {
      selectDetailsValues.push({
        name: this.translate.instant('lang.globals.device') + ' ' + screen.device.id,
        value: screen.device.id,
        description: this.translate.instant('lang.globals.screen') + ' ' + screen.id,
      });
    }

    this.modalService
      .selectWithDetails({
        values: selectDetailsValues,
        initialValue: null,
        yes: this.translate.instant('lang.globals.showDevice'),
        no: this.translate.instant('lang.globals.cancel'),
        message: '',
        title: 'Screens',
        modalOptions: { size: 'xl' },
      })
      .then((e: SelectDetailsResult<number>) => {
        if (e?.value) {
          this.navService.navigateToPoint(
            RoutingID.deviceDetailsOverview,
            [
              {
                id: 'deviceID',
                value: e.value.value,
              },
            ],
            { target: '_blank' }
          );
        }
      });
  }

  showClients(id: number) {
    if (id) {
      this.modalService
        .modal(
          {
            title: this.translate.instant('lang.globals.preview'),
            modalOptions: { size: 'sm' },
          },
          {
            templateId: 'sbPreviewListModal',
          },
          id
        )
        .then(() => {})
        .catch(() => {});
    }
  }

  getOrderNums(slot: PlaybackScheduleSlotFullDTO): number[] {
    return slot.fallbackOrderNum.map(x => x + 1);
  }
}
